// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectableArea{
    position: relative;
    width: 100%;
    height: 100%;
}

.SelectableArea_rect{
    position: absolute;
    pointer-events: none;
    background-color: #0002;
    border: 1px dotted #0008;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/desktop/SelectableArea.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,wBAAwB;AAC5B","sourcesContent":[".SelectableArea{\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.SelectableArea_rect{\n    position: absolute;\n    pointer-events: none;\n    background-color: #0002;\n    border: 1px dotted #0008;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
